import ActivityFast from './ActivityFast';

export default ActivityFast;
